import { render, staticRenderFns } from "./desktopDeclination3.vue?vue&type=template&id=0da581b4&scoped=true&"
import script from "./desktopDeclination3.vue?vue&type=script&lang=ts&"
export * from "./desktopDeclination3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da581b4",
  null
  
)

export default component.exports